import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import ChangePassword from '../Settings/ProfileSections/ChangePassword'
const regexExp = /^[a-f0-9]{64}$/gi

export const ResetPassword = ({ userToken = '' }) => {

    const navigate = useNavigate()

    const goToLogin = () => {
        navigate('/')
    }
    useEffect(() => {
        if (!regexExp.test(userToken)) goToLogin()
    }, [userToken])
    
    return (
        
        <div className='login'>
            <div className='login-container'>
                <ChangePassword userToken={userToken} updatePassword={goToLogin} />
            </div>
        </div>
    )
}

export default ResetPassword